import React from "react";
import SubPageTemplate from "../../components/subpagetemplate";
import { useCategoryOffers } from "../../hooks/useCategoryOffers";
import HelmetSeo from "../../components/HelmetSeo";
import { pageSeoConfig } from "../../config/pageSeo";

const Others: React.FC = () => {
  const othersData = useCategoryOffers("others");
  const seoMeta = pageSeoConfig.others;

  return (
    <>
      <HelmetSeo title={seoMeta.title} description={seoMeta.description} />
      <SubPageTemplate standard_categories={othersData} title="Others" />
    </>
  );
};

export default Others;
